import React from "react";
import { messageDataType } from "components/Messages/types";
import { ListGroup } from "react-bootstrap";
import "../../styles.scss";
import { getFormattedTime } from "components/Messages/utils";
import { useTranslation } from "react-i18next";

type Props = {
  message: messageDataType;
};
const Message = ({ message }: Props) => {
  const { t } = useTranslation();
  return (
    <ListGroup.Item
      className="list-group-item-extend"
      key={message?.id}
      style={{
        backgroundColor: message?.sentByController ? "#7fedff" : "#7fffd4",
        alignSelf: message?.sentByController ? "flex-start" : "flex-end",
      }}
    >
      <strong>{message?.senderName}</strong>
      {message?.sentByControlCenter && (
        <p className="message-subtitle">
          <strong>{t("sentByControlCenter")}</strong>
        </p>
      )}
      <p className="content">{message?.content}</p>
      <div className="time">{getFormattedTime(message?.date)}</div>
    </ListGroup.Item>
  );
};

export default Message;
